import { render, staticRenderFns } from "./scene13.vue?vue&type=template&id=66b16c4e&scoped=true&"
import script from "./scene13.vue?vue&type=script&lang=ts&"
export * from "./scene13.vue?vue&type=script&lang=ts&"
import style0 from "./scene13.vue?vue&type=style&index=0&id=66b16c4e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b16c4e",
  null
  
)

export default component.exports